<template>
  <div class="login">
    <div class="grid">
    <div class="brand_box">
      <div class="logo"></div>
      <h2 class="title is-4 has-text-primary has-text-centered">
        Scale Academy
      </h2>
      <p class="has-text-centered">
        Login to access training content or contact ADFG to register.
      </p>
    </div>
    <div class="login_box">
      <h1 class="title is-4">Login</h1>
      <form @submit.prevent="submit" novalidate>
        <div class="field">
          <div class="control">
            <input
              class="input is-medium"
              type="text"
              placeholder="Username or Email"
              v-model.trim="$v.form.email.$model"
              :class="{ 'is-danger': $v.form.email.$error }"
            />
            <div class="error" v-if="$v.form.email.$error">
              Username or Email is required
            </div>
          </div>
        </div>

        <div class="field">
          <div class="control">
            <input
              class="input is-medium"
              type="password"
              placeholder="Password"
              v-model.trim="$v.form.password.$model"
              :class="{ 'is-danger': $v.form.email.$error }"
            />
            <div class="error" v-if="$v.form.password.$error">
              Password is required
            </div>
          </div>
        </div>
        <b-button
          native-type="submit"
          class="button is-block is-primary is-fullwidth is-medium"
          :loading="loading"
          >Login</b-button
        >
        <br />
        <router-link to="/forgot"><small>Forgot Password?</small></router-link>
      </form>
    </div>
    <div class="social_box">
      <nav class="level">
        <div class="level-left">
          <div class="level-item">
            <span class="icon">
              <font-awesome-icon :icon="['fab', 'twitter']" />
            </span>
            &emsp;
            <span class="icon">
              <font-awesome-icon :icon="['fab', 'facebook']" />
            </span>
            &emsp;
            <span class="icon">
              <font-awesome-icon :icon="['fab', 'instagram']" />
            </span>
            &emsp;
            <span class="icon">
              <font-awesome-icon :icon="['fas', 'envelope']" />
            </span>
          </div>
        </div>
        <div class="level-right">
          <small class="level-item" style="color: var(--textLight)">
            &copy;{{ $date(new Date(), "yyyy") }} Designori, LLC. All Rights
            Reserved.
          </small>
        </div>
      </nav>
    </div>
    <!-- <div class="columns is-multiline">
      <div class="column is-8 is-offset-2 register is-12-mobile">
        <div class="columns">
          <div class="column left">
            <div class="logo"></div>
            <h2 class="title is-4 has-text-primary has-text-centered">
              Scale Academy
            </h2>
            <p class="has-text-centered">
              Login to access training content or contact ADFG to register.
            </p>
          </div>
          <div class="column right has-text-centered">
            <h1 class="title is-4">Login</h1>
            <form @submit.prevent="submit" novalidate>
              <div class="field">
                <div class="control">
                  <input
                    class="input is-medium"
                    type="text"
                    placeholder="Username or Email"
                    v-model.trim="$v.form.email.$model"
                    :class="{ 'is-danger': $v.form.email.$error }"
                  />
                  <div class="error" v-if="$v.form.email.$error">
                    Username or Email is required
                  </div>
                </div>
              </div>

              <div class="field">
                <div class="control">
                  <input
                    class="input is-medium"
                    type="password"
                    placeholder="Password"
                    v-model.trim="$v.form.password.$model"
                    :class="{ 'is-danger': $v.form.email.$error }"
                  />
                  <div class="error" v-if="$v.form.password.$error">
                    Password is required
                  </div>
                </div>
              </div>
              <b-button
                native-type="submit"
                class="button is-block is-primary is-fullwidth is-medium"
                :loading="loading"
                >Login</b-button
              >
              <br />
              <router-link to="/forgot"><small>Forgot Password?</small></router-link>
            </form>
          </div>
        </div>
      </div>
      <div class="column is-8 is-offset-2">
        <br />
        <nav class="level">
          <div class="level-left">
            <div class="level-item">
              <span class="icon">
                <font-awesome-icon :icon="['fab', 'twitter']" />
              </span>
              &emsp;
              <span class="icon">
                <font-awesome-icon :icon="['fab', 'facebook']" />
              </span>
              &emsp;
              <span class="icon">
                <font-awesome-icon :icon="['fab', 'instagram']" />
              </span>
              &emsp;
              <span class="icon">
                <font-awesome-icon :icon="['fas', 'envelope']" />
              </span>
            </div>
          </div>
          <div class="level-right">
            <small class="level-item" style="color: var(--textLight)">
              &copy;{{ $date(new Date(), "yyyy") }} Designori, LLC. All Rights
              Reserved.
            </small>
          </div>
        </nav>
      </div>
    </div> -->
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import AuthService from "../services/auth.service";

export default {
  name: "Login",
  data() {
    return {
      form: {
        email: "",
        password: ""
      },
      loading: false,
      message: ""
    };
  },
  validations: {
    form: {
      email: {
        required
      },
      password: {
        required
      }
    }
  },
  created() {
    if (this.loggedIn) {
      this.$router.push("/dashboad");
    }
  },
  methods: {
    submit() {
      this.$v.form.$touch();

      // if its still pending or an error is returned do not submit
      if (this.$v.form.$pending || this.$v.form.$error) {
        return;
      } else {
        // form clean, submit
        this.loading = true;
        AuthService.login(this.form)
          .then(user => {
            this.$store.dispatch("auth/login", user);
            this.$router.push("/dashboard");
          })
          .catch(err => {
            console.log(
              "catch auth return: ",
              err.response.data.message[0].messages[0].message
            );
            this.loading = false;
            this.$buefy.toast.open({
              duration: 2000,
              message: err.response.data.message[0].messages[0].message,
              position: "is-bottom",
              type: "is-danger"
            });
          });
      }
    }
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../theme.scss";

.login {
  width: 100vw;
  height: 100vh;
  background-color: rgb(247, 247, 247);
  display: flex;
  align-items: center;

  .grid {
    display: grid;
    margin: 0 auto;
    grid-template-columns: 450px 450px;
    grid-template-rows: 400px 50px;
  }

  .brand_box {
    padding: 50px;
    background-color: white;
    border-radius: 15px 0px 0px 15px;
  }

  .login_box {
    padding: 50px;
    background-color: white;
    border-radius: 0px 15px 15px 0px;
  }

  .social_box {
    padding: 7px 15px;
    grid-column: 1 / 3;
  }
}

@media (max-width: 700px) {
  .login {
    overflow-y: scroll;
    display: block;

    .grid {
      margin: 0 auto;
      display: block;
      width: 400px;
      margin-top: 25px;
    }

    .brand_box {
      height: 300px;
      border-radius: 15px 15px 0px 0px;
    }

    .login_box {
      grid-column: 1 / 2;
      border-radius: 0px 0px 15px 15px;
    }

    .social_box {
      grid-column: 1 / 2;
    }
  }
}

:root {
  --brandColor: $primary;
  --background: rgb(247, 247, 247);
  --textDark: hsla(0, 0%, 0%, 0.66);
  --textLight: hsla(0, 0%, 0%, 0.33);
}

.logo {
  background: url("~@/assets/logo.png") no-repeat center center;
  width: 250px;
  height: 150px;
  background-size: contain;
  margin: 0 auto;
  margin-bottom: 25px;
}

.field:not(:last-child) {
  margin-bottom: 1rem;
}

.register {
  margin-top: 10rem;
  background: white;
  border-radius: 10px;
}

.brand_box,
.login_box {
  padding: 4.5rem;
}

.brand_box {
  border-right: 5px solid var(--background);
}

.brand_box p {
  color: var(--textLight);
  font-size: 1.15rem;
}

.login_box .title {
  font-weight: 900;
}

.login_box .description {
  margin-top: 1rem;
  margin-bottom: 1rem !important;
  color: var(--textLight);
  font-size: 1.15rem;
}

input {
  font-size: 1rem;
}

input:focus {
  border-color: var(--brandColor) !important;
  box-shadow: 0 0 0 1px var(--brandColor) !important;
}

.icon {
  color: var(--textLight);
  margin-right: 1rem;
}

.error {
  font-size: 12px;
  color: red;
}
</style>
